module.exports = __webpack_public_path__ + "static/media/inflightdublin.b5292b8b.png";